<template>
  <ActiveProductMenuWrapper>
    <template v-slot:menu>
      <article class="menu-container">
        <!-- Show decorations list -->
        <template v-if="currentComponent === 'DecorationsList'">
          <template v-if="showAddDecorationsButton">
            <div class="header-label">
              <p class="slate-bold">Add New Decoration</p>
              <!-- Switch indicator (Outside/Inside) -->
              <div
                class="switch-indicator"
                v-if="isActiveProductReversible"
                @click="handleChangeReversibleView()"
              >
                <p :class="{ active: reversibleView === 'Outside' }">Outside</p>
                <p :class="{ active: reversibleView === 'Inside' }">Inside</p>
              </div>
            </div>
            <!-- Add decorations -->
            <button
              id="add-decoration-button"
              @click="currentComponent = 'AddDecorations'"
            >
              <img
                src="@/assets/icons/ui/add-circle-outline-black.svg"
                alt="add icon"
              />
              <span>Add Decoration</span>
            </button>
          </template>

          <!-- Decoration prices info message -->
          <div class="decoration-price-info" v-if="showDecorationInfoMessage">
            <p>
              <!-- Sublimation message -->
              <template v-if="isSublimated3D">
                <span>Chromagear items have all inclusive pricing - </span>
                <span class="slate-bold"
                  >add unlimited decorations with no upcharges!</span
                >
              </template>
              <template v-else>
                <span
                  >Decorations for this item cost extra. Prices shown are an
                  estimate.
                </span>
                <span class="slate-bold"
                  >Final pricing varies based on number of decorations, their
                  colors and materials, as well as total quantity ordered.</span
                >
              </template>
            </p>
            <button @click="showDecorationInfoMessage = false">
              <CloseSVG fillColor="#0a80ed" />
            </button>
          </div>

          <!-- Decorations list items-->

          <ul id="decorations-list" v-if="hasDecorations">
            <li class="slate-bold">Decorations</li>

            <li
              v-for="(decoration, i) in decorations3DListByReversibleView"
              :key="i + '-3d-deco'"
              class="decorations-item"
            >
              <article class="decoration-row">
                <div class="decoration-label slate-bold">
                  <div class="decoration-info">
                    <img
                      v-if="decoration && decorationLabel(decoration)"
                      :src="
                        require(`@/assets/icons/ui/decoration-icon-${decorationLabel(
                          decoration
                        )}.png`)
                      "
                      alt="decoration label"
                    />
                    <p>{{ decorationLabel(decoration) }}</p>
                  </div>
                  <div
                    v-if="decoration && decoration.price && !isSublimated3D"
                    class="decoration-price"
                  >
                    <img
                      src="@/assets/icons/ui/wallet-outline.png"
                      alt="decoration price icon"
                    />
                    <span>${{ decoration.price.toFixed(2) }}</span>
                  </div>
                  <div class="decoration-info-detail">
                    <img
                      v-if="decoration"
                      :src="
                        require(`@/assets/icons/ui/decoration-icon-${decorationLabel(
                          decoration
                        )}.png`)
                      "
                      alt="decoration label"
                    />
                    <div class="detail-column">
                      <p>
                        {{
                          decoration && decoration.configuration["Content Type"]
                        }}
                      </p>
                      <p>
                        <span>{{ decoration && decoration.view }}</span>
                        <span
                          >({{ decoration && decoration.locationName }})</span
                        >
                      </p>
                    </div>
                    <div class="detail-column size">
                      <p>
                        {{
                          decoration && decoration.configuration["Text Height"]
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="decoration-preview-container">
                  <!-- Logo -->
                  <template v-if="decorationIsLogo(decoration)">
                    <!-- <img :src="logo.content || logo.url" alt="product logo" />-->
                    <button
                      class="edit-decoration btn"
                      @click="handleSetActiveDecoration(decoration)"
                    >
                      <img src="~@/assets/edit.svg" alt="Customize icon" />
                      <span>Edit Decoration</span>
                    </button>
                    <img :src="decoration.thumbnail" alt="logo" />
                  </template>

                  <!-- Text -->
                  <template v-else>
                    <!-- <TextStamp
                      :showAsCommonImage="true"
                      :layout="layout"
                      :fieldName="'name'"
                      :fill="textStampName.fill"
                      :outline="textStampName.outline"
                      :value="textStampName.value"
                      :font="textStampName.font"
                    /> -->
                    <img
                      :src="decoration.thumbnail"
                      :alt="
                        'text decoration: ' + decoration.configuration['Text']
                      "
                    />
                    <button
                      class="edit-decoration btn"
                      @click="handleSetActiveDecoration(decoration)"
                    >
                      <img src="~@/assets/edit.svg" alt="Customize icon" />
                      <span>Edit Decoration</span>
                    </button>
                  </template>
                </div>
                <div class="item-actions">
                  <!-- Copy Button -->
                  <button
                    class="btn duplicate-btn"
                    :key="i + '-3d-deco-delete'"
                    @click="handleCopyDecoration(decoration)"
                  >
                    <img
                      src="@/assets/icons/ui/duplicate-outline.png"
                      alt="duplicate"
                    />
                  </button>
                  <!-- Delete Action -->
                  <DeleteButton
                    @click.native="handleDeleteDecoration(decoration)"
                  />
                </div>
              </article>
            </li>
          </ul>

          <!-- Layout Selection -->
          <!-- Hide temporary -->
          <!-- <div class="edit-logo-row-container" v-if="hasLayouts">
            <p class="decoration-type-label">Location</p>

            <div class="layouts-options-container">
              <label
                :for="layout.id + '-layout-opt'"
                v-for="(layout, i) in product.layouts"
                :key="i + '-layout-opt'"
              >
                <input
                  :id="layout.id + '-layout-opt'"
                  name="product-layout"
                  type="radio"
                  :checked="activeLayoutId === layout.id"
                  :value="layout.id"
                  @change="handleSetProductActiveLayout(layout.id)"
                />
                <span>{{ layout.name }}</span>
              </label>
            </div>
          </div> -->
        </template>

        <!-- Add Decorations -->
        <AddDecoration
          v-if="currentComponent === 'AddDecorations'"
          :activeDecorationIsEmpty="activeDecorationIsEmpty"
          :layoutAllowsLogo="layoutAllowsLogo"
          :layoutAllowsText="layoutAllowsText"
          @hideAddDecorations="setDecorationsListAsCurrentComponent()"
          @openGraphicsLibrary="$emit('openGraphicsLibrary')"
        />
      </article>
    </template>

    <!-- Navigation buttons and Price summary -->
    <template v-slot:buttons>
      <!-- Back and Next, Decoration List -->
      <!-- <template v-if="currentComponent === 'DecorationsList'">
        <button class="col-4 btn-transparent" @click="handleBackButton()">
          <img
            src="@/assets/icons/ui/chevron-back-outline-grey.svg"
            alt="back"
          />
          Back
        </button>
        <button class="col-4 btn" @click="close()">
          {{
            modalLoading
              ? "Loading..."
              : decorationsAvailable
              ? "Add to locker"
              : "Save"
          }}
        </button>
      </template> -->

      <!-- Cancel / Save Add/Edit decorations -->
      <template v-if="currentComponent === 'AddDecorations'">
        <div class="footer-container">
          <div id="navigation-buttons">
            <button
              class="col-4 btn cancel forza-bold"
              @click="handleCancelDecoration()"
            >
              Cancel
            </button>
            <button
              class="col-4 btn save forza-bold"
              @click="handleSaveDecoration()"
              :disabled="activeDecorationIsEmpty || modalLoading"
            >
              {{ modalLoading ? "Loading..." : "Save Decoration" }}
            </button>
          </div>
        </div>
      </template>

      <!-- Save Edit Decoration -->
      <template v-if="currentComponent === 'EditActiveProductLogo'">
        <div class="footer-container">
          <div id="navigation-buttons">
            <button class="col-4 btn save forza-bold">Save</button>
          </div>
        </div>
      </template>

      <!-- Save or Cancel New or Edited decorations -->
      <!-- <template v-else>
        <button class="col-4 btn " @click="handleCancelDecoration()">
          Cancel
        </button>
        <button class="col-4 btn btn-primary" @click="handleSaveDecoration()">
          Save
        </button>
      </template> -->
    </template>
  </ActiveProductMenuWrapper>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ActiveProductMenuWrapper from "@/components/Projects/Project/ActiveProduct/ActiveProductMenuWrapper.vue";
import AddDecoration from "@/components/Projects/Project/ActiveProduct/Decorations/AddDecoration.vue";
import DeleteButton from "@/components/Utils/DeleteButton.vue";
import CloseSVG from "@/components/Utils/Svgs/CloseSVG.vue";
import { cloneDeep } from "lodash";

export default {
  name: "ActiveProductDecorations",
  props: {
    product: {
      type: Object,
    },
    modalLoading: {
      type: Boolean,
    },
  },

  data() {
    return {
      currentComponent: "DecorationsList",
      componentsToShow: ["DecorationsList", "AddDecorations"],
      addDecorationSwitch: "logo", // -> Add Decoration switch (logo/text)
      textStampSelectedOption: "name",
      showOnlyOnceTextStampOption: false,
      showDecorationInfoMessage: true,
      editedLogo: {},
      loading: false,
    };
  },

  computed: {
    ...mapState("project", ["activeProduct", "editableProduct"]),
    ...mapGetters("project", [
      "getLogoById",
      "getColorById",
      "isSnapsheet",
      "isPlaybook",
      "defaultLogo",
      "projectColors",
      "getProductTextStamp",
    ]),
    ...mapState("threekit", ["activeDecoration", "reversibleView"]),

    ...mapGetters("threekit", [
      "activeDecorationAvailableLocations",
      "activeDecorationAvailableLocationsByContentType",
      "decorations3DListByReversibleView",
      "isActiveProductReversible",
      "isSublimated3D",
    ]),
    activeDecorationIsEmpty() {
      return (
        !this.activeDecoration?.["configuration"]?.["Logo"]?.["assetId"] &&
        !this.activeDecoration?.["configuration"]?.["Text"]
      );
    },
    showAddDecorationsButton() {
      return this.layoutAllowsLogo || this.layoutAllowsText;
    },

    isUniformAndPlaybookProduct() {
      return this.isPlaybook && this.product.is_uniform;
    },

    hasDecorations() {
      //Old 1.5 products
      // if (this.isSnapsheet) {
      //   if (!this.product.decorations || !this.product.decorations?.front)
      //     return false;

      //   const decorationsKeys = Object.keys(this.product.decorations.front);

      //   const someDecorationHasAnyValue = decorationsKeys.some(
      //     (decorationkey) => {
      //       if (decorationkey === "logo")
      //         return this.product.decorations.front[decorationkey]?.id;

      //       return this.product.decorations.front[decorationkey]?.value;
      //     }
      //   );
      //   return someDecorationHasAnyValue;
      // } else {
      //   return this.hasLogo || this.hasTeamName || this.hasNumber;
      // }

      return this.decorations3DListByReversibleView.length > 0;
    },

    hasLogo() {
      //Old 1.5 products
      // return this.logo != null && this.logo?.id != null;

      return (
        this.hasDecorations &&
        this.decorations3DListByReversibleView.some(
          (decoration) =>
            (decoration["Content Type"] === "Graphics" ||
              decoration["Content Type"] === "Uploads") &&
            decoration.Logo?.assetId
        )
      );
    },

    hasLayouts() {
      return this.product.layout;
    },

    hasTeamName() {
      //Old 1.5 products
      //in InstantPlaybooks, for uniforms products, allways display team name
      // if (this.isUniformAndPlaybookProduct) return true;

      // return !!this.textStampName?.value;

      return (
        this.hasDecorations &&
        this.decorations3DListByReversibleView.some(
          (decoration) =>
            decoration["Content Type"] === "Player Name" &&
            decoration.Text?.value
        )
      );
    },

    hasNumber() {
      //in InstantPlaybooks, for uniforms products, allways display number
      if (this.isPlaybook && this.product.is_uniform) return true;

      return !!this.textStampNumber?.value;
    },

    decorationsAvailable() {
      // return this.product.layouts
      //   ? this.product.layouts.length > 0
      //   : this.product.layout;
      return this.layoutAllowsLogo || this.layoutAllowsText;
    },

    activeLayoutId() {
      if (this.isSnapsheet) return this.product.activeLayoutId;
      //TODO FIND PLAYBOK PRODUCT ACTIVE LAYOUT
      return null;
    },

    layout() {
      const activeLayout =
        this.product.layouts?.find(
          (l) => l.id == this.product.activeLayoutId
        ) ||
        (this.product.layouts && this.product.layouts[0]);

      return (
        //First try to return the native snapsheet layout calculation
        activeLayout?.layout_attributes?.front || this.product.layout
      );
    },

    layoutAllowsLogo() {
      return (
        this.activeDecorationAvailableLocations(["Uploads", "Graphics"])
          ?.length > 0
      );
    },

    layoutAllowsText() {
      return (
        this.activeDecorationAvailableLocations([
          "Custom Text",
          "Player Name",
          "Player Number",
        ])?.length > 0
      );
    },

    layoutAllowsName() {
      return this.layout?.name;
    },

    layoutAllowsNumber() {
      return this.layout?.number;
    },

    textStampName() {
      return this.getProductTextStamp(this.product, "name");
    },

    textStampNumber() {
      return this.getProductTextStamp(this.product, "number");
    },

    textStampSelectedOptionLabel() {
      return this.textStampSelectedOption === "name" ? "Team Name" : "Number";
    },

    logo() {
      return (
        this.getLogoById(this.product.decorations?.front?.logo?.id) ||
        (this.isPlaybook && !this.product.is_uniform ? this.defaultLogo : null)
      );
    },

    overrideLogoPreviewsBackground() {
      if (this.isSnapsheet) {
        const variant = this.product.variants.filter(
          (variant) =>
            variant?.color_name?.trim() === this.product.variant?.trim()
        );
        const variantColorFamilyId = variant && variant[0]?.color_family;

        if (!variant || !variantColorFamilyId) return null;

        const colorHex = this.getColorById(variantColorFamilyId)?.hex;

        return colorHex;
      }

      //todo return project global color, or the playbook product color
      return null;
    },
  },

  methods: {
    ...mapActions("editableLogo", [
      "DIGIrequestImageAsBse64",
      "setEditableLogo",
      "setEditableLogoProperties",
    ]),
    ...mapActions("project", [
      "addToLocker",
      "applyProductDecorationsChanges",
      "setActiveProduct",
      "changeActiveProductLayout",
      "saveActiveProductToProject",
      "resetEditableProduct",
    ]),
    ...mapActions("threekit", [
      "cancelActiveDecoration",
      "changeLogo",
      "changeReversibleView",
      "close3DDecorations",
      "remove3DDecoration",
      "saveActiveDecoration",
      "set3DDecoration",
      "setActiveDecoration",
      "setLoadingState",
      "updateDecorationThumbnail",
    ]),

    setDecorationsListAsCurrentComponent() {
      this.currentComponent = "DecorationsList";
      this.$emit("hideEditableProduct");
    },

    setAddDecorationsAsCurrentComponent() {
      this.currentComponent = "AddDecorations";
      this.$emit("showEditableProduct");
    },

    async handleAddToLocker() {
      this.loading = true;
      try {
        await this.addToLocker({ product: this.product });
        this.emitOpenPreviewNewLockerProducts();
      } catch (error) {
        console.log(error);
        this.$store.dispatch("showToast", {
          txt: "Error trying to save the product",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    handleChangeReversibleView() {
      const newView = this.reversibleView === "Inside" ? "Outside" : "Inside";
      this.setLoadingState({
        loadingState: true,
        message: "Applying Changes...",
      });
      setTimeout(() => {
        this.$nextTick(async () => {
          try {
            await this.changeReversibleView(newView);
          } catch (error) {
            console.log(error);
          } finally {
            this.setLoadingState({ loadingState: false });
          }
        });
      }, 100);
    },

    async handleSetActiveDecoration(decoration) {
      //Set the active decoration before we show the AddDecorations component
      await this.setActiveDecoration({
        ...decoration,
        saveOriginalDecorationLocation: true,
      });
      this.$nextTick(() => {
        this.currentComponent = "AddDecorations";
      });
    },

    async handleShowEditableLogo() {
      try {
        const base64 =
          this.logo.content ||
          (await this.DIGIrequestImageAsBse64(this.logo.url));
        await this.setEditableLogo({ content: base64 });
        await this.setEditableLogoProperties({
          zoom: this.product.decorations?.front?.logo.zoom,
          position: this.product.decorations?.front?.logo.position,
        });
      } catch (error) {
        console.log(error);
      }
    },

    //This only shows how the screen will be, and it is applied in the activeProduct, so it does not affect the original product unless the user save changes
    handleApplyLogoChanges(screenLogoProperties) {
      this.editedLogo = { ...this.logo, ...screenLogoProperties };
      this.applyProductDecorationsChanges({
        TYPE_OF_PRODUCT: "activeProduct",
        decorationPropertyName: "logo",
        decorationPropertyValue: this.editedLogo,
        // Todo -> En teoria aca guardamos los cambios temporales en Editable product, para dar la chance del 'Cancel', pero por ahora lo applicamos directo, por pedido de nacho por ahora no hay cancel
        // TYPE_OF_PRODUCT: "editableProduct",
      });
    },

    async handleChangeLogo(logo) {
      this.applyProductDecorationsChanges({
        TYPE_OF_PRODUCT: "activeProduct",
        decorationPropertyName: "logo",
        decorationPropertyValue: logo,
      });
      this.setDecorationsListAsCurrentComponent();
      this.handleShowEditableLogo();
      if (logo.asset_id) {
        this.setLoadingState({
          loadingState: true,
          message: "Applying Changes...",
        });

        setTimeout(() => {
          this.$nextTick(async () => {
            try {
              await this.changeLogo(logo);
            } catch (error) {
              console.log(error);
            } finally {
              this.setLoadingState({
                loadingState: true,
                message: "Applying Changes...",
              });
            }
          });
        }, 100);
      }
    },

    async handleCopyDecoration(decoration) {
      try {
        this.setLoadingState({
          loadingState: true,
          message: "Applying Changes...",
        });

        const decorationContentType =
          decoration?.configuration?.["Content Type"];

        //Check wich decorations locations are possible to apply for this type of decoration
        const possibleDecorationsLocations =
          this.activeDecorationAvailableLocationsByContentType[
            decorationContentType
          ];

        //Find the first location that is not being used
        const newLocation = possibleDecorationsLocations?.find(
          (possibleLocation) => {
            const isIn = this.decorations3DListByReversibleView?.find(
              (decorationInList) => {
                return decorationInList.locationName === possibleLocation;
              }
            );

            return !isIn;
          }
        );

        if (newLocation) {
          await this.set3DDecoration({
            locationName: newLocation,
            configuration: cloneDeep({
              ...decoration.configuration,
              ["Location Shortcode"]: newLocation.match(/\b(\w)/g).join(""),
            }),
            saveDecoration: true,
            setView: true,
            skipDecorationAllowedControl: true,
          });

          await this.updateDecorationThumbnail(newLocation);
        } else {
          //todo : show a popup indicating that there is no location available
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.setLoadingState({ loadingState: false });
      }
    },

    async handleDeleteDecoration(decoration) {
      this.setLoadingState({
        loadingState: true,
        message: "Applying Changes...",
      });

      setTimeout(() => {
        this.$nextTick(async () => {
          try {
            await this.remove3DDecoration(decoration.locationName);
          } catch (error) {
            console.log(error);
          } finally {
            this.setLoadingState({ loadingState: false });
          }
        });
      }, 100);
    },

    async handleDeleteLogo() {
      this.editedLogo = {};
      this.applyProductDecorationsChanges({
        TYPE_OF_PRODUCT: "activeProduct",
        decorationPropertyName: "logo",
        decorationPropertyValue: {},
      });
      this.$nextTick(async () => {
        await this.changeLogo("");
      });
    },

    handleSetProductActiveLayout(layoutId) {
      this.changeActiveProductLayout(layoutId);
    },

    async handleSaveDecoration() {
      if (!this.modalLoading) {
        try {
          this.$emit("setLoading");
          await this.saveActiveDecoration();
          this.currentComponent = "DecorationsList";
          // this.setActiveProduct({ product: null });
        } catch (error) {
          console.log("handleSaveDecoration", error);
        } finally {
          this.$emit("unsetLoading");
        }
      }
    },
    async handleCancelDecoration() {
      if (!this.modalLoading) {
        try {
          this.$emit("setLoading");
          this.currentComponent = "DecorationsList";
          await this.cancelActiveDecoration();
          // this.setActiveProduct({ product: null });
        } catch (error) {
          console.log(error);
        } finally {
          this.$emit("unsetLoading");
        }
      }
    },

    handleDeleteTextStamp(decorationPropertyName) {
      this.applyProductDecorationsChanges({
        TYPE_OF_PRODUCT: "activeProduct",
        decorationPropertyName,
        decorationPropertyValue: {},
      });
    },

    goToEditTextStamp(textStampOption) {
      this.currentComponent = "AddDecorations";
      this.addDecorationSwitch = "text";
      this.textStampSelectedOption = textStampOption;
      this.showOnlyOnceTextStampOption = true;
    },

    handleBackButton() {
      this.resetEditableProduct();
      this.setDecorationsListAsCurrentComponent();
      this.$emit("back");
    },

    emitOpenPreviewNewLockerProducts() {
      this.$emit("openPreviewNewLockerProducts");
    },

    //3D Calculation
    decorationIsLogo(decoration) {
      return (
        decoration.configuration?.["Content Type"] === "Graphics" ||
        decoration.configuration?.["Content Type"] === "Uploads"
      );
    },

    decorationLabel(decoration) {
      if (!decoration?.configuration?.["Content Type"]) return "number";
      //Take the last word from the content type
      return this.decorationIsLogo(decoration)
        ? "graphic"
        : decoration.configuration?.["Content Type"]
            ?.split(" ")
            .pop()
            ?.toLowerCase();
    },

    close() {
      this.setActiveProduct({ product: null });
      this.close3DDecorations();
    },
  },

  watch: {
    currentComponent(newValue) {
      //Check if the product layout allows logo or text stamp, and set the Switch to the correct value
      if (newValue === "AddDecorations") {
        if (this.addDecorationSwitch === "logo" && !this.layoutAllowsLogo) {
          this.addDecorationSwitch = "text";
        }
        if (this.addDecorationSwitch === "text" && !this.layoutAllowsText) {
          this.addDecorationSwitch = "logo";
        }
      }

      //Reset the textstamp edition value that makes the component to show only once textstamp input
      if (newValue === "DecorationsList") {
        this.showOnlyOnceTextStampOption = false;
      }
    },
  },

  components: {
    ActiveProductMenuWrapper,
    AddDecoration,
    DeleteButton,
    CloseSVG,
    // TextStamp,
  },

  mounted() {
    if (this.hasLogo) this.handleShowEditableLogo();
  },
};
</script>

<style lang="scss" scoped>
.menu-container {
  .header-label {
    display: flex;
    margin-bottom: 1rem;
    .switch-indicator {
      background-color: $grey-lightest;
      border: 1px solid $borderColor;
      cursor: pointer;
      display: flex;
      margin-left: 1rem;
      border-radius: 10px;
      p {
        border-radius: 10px;
        color: $grey-light;
        padding: 0 0.25rem;
        width: 60px;
        text-align: center;
        transition: all 0.5s;
        &.active {
          border: 1px solid $grey-dark;
          color: $grey-dark;
        }
      }
    }
  }

  .decoration-price-info {
    display: flex;
    background: #eef3ff;
    margin-bottom: 1.5rem;
    padding: 1rem;
    width: calc(100% + 3.5rem);
    margin-left: -2.5rem;
    span {
      color: $showroomColor;
    }
    button {
      margin-left: auto;
      background: none;
    }
  }

  #decorations-list {
    display: flex;
    flex-flow: column;
    width: 100%;

    li {
      list-style: none;
      margin-bottom: 1.5rem;
    }

    .decorations-item {
      display: flex;
      flex-flow: column;
      list-style: none;
      .decoration-row {
        display: flex;
        gap: 1.5rem;
        width: 100%;
        .decoration-label {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          margin-bottom: 0.5rem;
          width: 15%;
          position: relative;

          & > * {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            margin-bottom: 0.5rem;
            width: 100%;

            img {
              margin-right: 1rem;
            }
          }
          &:hover {
            .decoration-info-detail {
              opacity: 1;
            }
          }
          img {
            height: 1rem;
            margin-right: 1rem;
          }
          span,
          p {
            text-transform: capitalize;
            color: $grey-dark;
            font-size: 1rem;
          }
          .decoration-info-detail {
            opacity: 0;
            display: flex;
            align-items: center;
            z-index: 1;
            background: white;
            border-radius: 6px;
            padding: 0.5rem 0.75rem;
            box-shadow: 0 0 0.5rem 0.5rem rgba(0, 0, 0, 0.1);
            transition: all 0.2s;
            position: absolute;
            left: 0;
            min-width: 300%;
            pointer-events: none;
            img {
              margin-right: 0.5rem;
            }
            .detail-column {
              display: flex;
              flex-direction: column;
              margin: auto;

              &.size {
                margin: 0;
                margin-top: auto;
              }
            }
          }
        }

        .decoration-preview-container {
          align-items: center;
          background: $grey-lighter;
          border-radius: 6px;
          border: 2px solid $borderColor;
          display: flex;
          flex-direction: column;
          /* flex-grow: 1; */
          height: 85px;
          justify-content: center;
          padding: 0.5rem 1rem;
          position: relative;
          width: 60%;
          &:hover {
            button.edit-decoration {
              opacity: 1;
              pointer-events: initial;
              z-index: 1;
            }
          }
          img {
            max-height: 100%;
            max-width: 100%;
            margin-right: 0.5rem;
          }

          button.edit-decoration {
            background: $dark;
            position: absolute;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            text-align: center;
            opacity: 0;
            pointer-events: none;
            width: 50%;
            z-index: -1;
            span {
              color: white;
            }
          }
        }

        ::v-deep .delete-btn,
        .duplicate-btn {
          background: $grey-lightest;
          border: 1px solid $grey-lighter;
          border-radius: 6px;
          width: 2rem;
          height: 2rem;
          margin-bottom: 0.75rem;
          img {
            width: 1.25rem;
          }
        }
      }
    }
  }

  .edit-logo-row-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
    p.decoration-type-label {
      margin-bottom: 0.75rem;
      font-weight: bold;
      width: 100%;
    }
    ::v-deep .edit-logo-container {
      width: 80%;
    }

    .delete-logo-column {
      width: 15%;
    }

    .decoration-row {
      display: flex;
      justify-content: space-between;
      .decoration-row-box {
        background: $grey-lightest;
        border-radius: 6px;

        border: 1px solid $placeholder;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        height: 70px;
        width: 80%;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      .buttons-container {
        display: flex;
        flex-flow: column;
      }
    }

    .layouts-options-container {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      width: 100%;
      label {
        display: flex;
        align-items: center;
        width: 40%;
        input {
          margin-right: 0.5rem;
        }
      }
    }
  }

  .logos-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    ::v-deep .logo-box {
      width: 60px;
      height: 60px;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
      }
    }
  }

  #add-decoration-button {
    background-color: white;
    border: 0.780556px dashed $grey-dark;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    padding: 1rem 0.75rem;
    row-gap: 0.5rem;
    text-overflow: ellipsis;
    width: 45%;
    min-width: fit-content;

    img {
      margin-right: 0.5rem;
    }

    span {
      color: $grey-dark;
      font-size: 1rem;
      line-height: 16px;
    }

    .allowed-formats {
      color: $placeholder;
      font-size: 0.75rem;
    }
  }
}
</style>
